const translations = {
  app: {
    company: 'Afosto',
    title: 'Files',
    searchBar: {
      search: {
        label: 'Search',
        placeholder: 'Search',
      },
    },
    dock: {
      iam: 'Dashboard',
      spl: 'Spooler',
      cnt: 'Files',
      dashboard: 'Overview',
      notifications: 'Notifications',
      picker: 'Picker',
      spooler: 'Spooler',
      user: 'User',
      userMenu: {
        signOut: 'Sign out',
      },
      notificationsMenu: {
        none: 'No notifications',
        all: 'All notifications',
      },
    },
    navigation: {
      main: {
        files: 'Files',
        settings: 'Settings',
      },
    },
  },
  pages: {
    settings: {
      title: 'Settings',
      create: {
        title: 'New setting',
        button: 'Add',
      },
      subNavigation: {
        general: 'General',
        proxySettings: 'Proxy settings',
      },
    },
  },
  dataGrid: {
    selection: {
      button: {
        all: 'All',
      },
      selected: '{count} selected',
    },
    pagination: {
      currentPageLabel: 'Page {page}',
      displayedRows: '{from}-{to} of {count}',
      rowsPerPage: 'Rows per page:',
    },
    columnSelection: {
      selectedColumns: 'Column selection',
      availableColumns: 'Available columns',
      title: 'Columns',
    },
    filterSelection: {
      title: 'Filters',
    },
  },
  actions: {
    add: 'Add',
    cancel: 'Cancel',
    delete: 'Delete',
    filter: 'Filter',
    goToList: 'Show all',
    save: 'Save',
  },
  pagination: {
    pageNumber: 'Page {i}',
  },
  properties: {
    path: 'Path',
  },
  errors: {
    validation: {
      empty: '{target} can not be empty',
    },
  },
};

export default translations;
